// extracted by mini-css-extract-plugin
export default {"sub-main":"CardComingSoon_sub-main__8Bdm6","title":"CardComingSoon_title__tE8l+","email":"CardComingSoon_email__5i2Bq"};